import styled from 'styled-components';

export const PartnerLogosSliderContainer = styled.div`
	background: #0b1a2f;
	text-align: center;
	position: relative;
`;

export const GradientLeft = styled.div(
	({ theme: { down, breakpoints } }) => `
	background-image: linear-gradient(to left, rgba(0, 0, 0, 0) 1%, #0b1a2f 98%);
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	z-index: 1;
	position: absolute;
	width: 300px;
		${down(breakpoints.md)} {
			width: 110px;
		}
	`
);

export const GradientRight = styled.div(
	({ theme: { down, breakpoints } }) => `
	background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 1%, #0b1a2f 98%);
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 1;
	position: absolute;
	width: 300px;
		${down(breakpoints.md)} {
			width: 110px;
		}
	`
);

export const PartneredCompaniesWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
	max-height: 500px;
	position: relative;
	z-index: 0
	${down(breakpoints.md)} {
		& .slick-slide{
			width: fit-content !important;
			display: flex !important;
		}
	}
	`
);

export const PartnerLogoWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
	max-height: 70px;
	background: #1A2E44;
	width: fit-content !important;
	box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.2);
	border-radius: 6px;
	padding: 22px;
	margin: 0 24px 24px 0; 
`
);
